import { DEFAULT_MARKETPLACE_NAME } from "@client-shared/lib/constants";
import type { CarrierCustomerAccountBinding, PurchaseOrder } from "@shared/types";

export const getMarketplaceDisplayName = (order: PurchaseOrder, carrierDetails?: CarrierCustomerAccountBinding[]): string => {
  const name = order.customerAccountName ?? "";

  if (order.isInternalAccount) {
    return DEFAULT_MARKETPLACE_NAME;
  }

  const groupedBinding = carrierDetails?.find((binding) =>
    binding.groupedCustomerAccounts?.some((groupedAccount) => groupedAccount.customerAccountNumber === order.customerAccountNumber)
  );
  const groupedAccount = groupedBinding?.groupedCustomerAccounts?.find(
    (groupedAccount) => groupedAccount.customerAccountNumber === order.customerAccountNumber
  );

  if (groupedAccount) return groupedAccount.customerAccountDisplayName;

  const topLevelBinding = carrierDetails?.find((binding) => binding.customerAccountNumber === order.customerAccountNumber);

  return topLevelBinding?.customerAccountDisplayName ?? name;
};
